import {
  LOGIN_INITIATED,
  LOGIN_SUCCEED,
  LOGIN_FAILED,
  LOGOUT,
} from "../constants/login.constants";

const initialState = {
  isLoading: false,
  isSignout: false,
  authInfo: null,
  error: null,
};

const loginReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LOGIN_INITIATED:
      return {
        ...state,
        isLoading: true,
      };
    case LOGIN_SUCCEED:
      return {
        ...state,
        isLoading: false,
        authInfo: action.payload,
      };
    case LOGIN_FAILED:
      return {
        ...state,
        isSignout: true,
        isLoading: false,
        authInfo: null,
      };
    case LOGOUT:
      return {
        ...state,
        isSignout: true,
        isLoading: false,
        authInfo: null,
      };
    default:
      return state;
  }
};

export default loginReducer;
